module.exports = __webpack_public_path__ + "static/media/Lato-Regular.122dd68d.ttf";